"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPresignResponseDto = instanceOfPresignResponseDto;
exports.PresignResponseDtoFromJSON = PresignResponseDtoFromJSON;
exports.PresignResponseDtoFromJSONTyped = PresignResponseDtoFromJSONTyped;
exports.PresignResponseDtoToJSON = PresignResponseDtoToJSON;
exports.PresignResponseDtoToJSONTyped = PresignResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PresignResponseDto interface.
 */
function instanceOfPresignResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('uploadUrl' in value) || value['uploadUrl'] === undefined)
        return false;
    if (!('method' in value) || value['method'] === undefined)
        return false;
    if (!('headers' in value) || value['headers'] === undefined)
        return false;
    if (!('objectKey' in value) || value['objectKey'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    return true;
}
function PresignResponseDtoFromJSON(json) {
    return PresignResponseDtoFromJSONTyped(json, false);
}
function PresignResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'uploadUrl': json['uploadUrl'],
        'method': json['method'],
        'headers': json['headers'],
        'objectKey': json['objectKey'],
        'expiresAt': json['expiresAt'],
    };
}
function PresignResponseDtoToJSON(json) {
    return PresignResponseDtoToJSONTyped(json, false);
}
function PresignResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'uploadUrl': value['uploadUrl'],
        'method': value['method'],
        'headers': value['headers'],
        'objectKey': value['objectKey'],
        'expiresAt': value['expiresAt'],
    };
}
